import {
  useAppState,
  useAppStateActions,
  useAssessmentResults,
  useLanguageDirection,
  useShowSegmentationCalculatorFeedback,
  useTranslation,
  useUsername
} from 'appState';
import { AspectRatioView, ButtonRect, HorizontalOrientationPrompt } from 'components';
import s from './GamesCompleted.module.scss';
import { getTop3Skills } from 'utils/skills';
import SegmentationFeedback from 'AppFlow/GamesCompleted/SegmentationFeedback';

const GamesCompleted: React.FC = () => {
  const willRedirect = useAppState(s => s.maybeRedirectOnGamesCompletion())
  const results = useAssessmentResults();
  const showSegmentationFeedback = useShowSegmentationCalculatorFeedback();
  const langAssessment = useTranslation('Assesment');
  const username = useUsername();
  const cognitiveStrengths = results && getTop3Skills(results, langAssessment);
  const dir = useLanguageDirection();
  const { appFlowForward } = useAppStateActions();
  const lang = useTranslation('GamesCompleted');

  if (willRedirect) {
    return null;
  }

  return (
    <>
      <HorizontalOrientationPrompt />
      <AspectRatioView>
        <div className={s.container}>
          <h3 className={s.title} dir={dir}>{lang.title}</h3>
          <div className={s.message} dir={dir}>
            {showSegmentationFeedback ? <SegmentationFeedback
              username={username}
              results={results}
              cognitiveStrengths={cognitiveStrengths}
            /> :
              <>{lang.message}</>
            }
          </div>
          <ButtonRect onClick={appFlowForward} text={lang.buttonLabel} />
        </div>
      </AspectRatioView>
    </>
  );
};

export default GamesCompleted;
